const loginReducer = (state = 'Login', action = { type: 'Login' }) => {
  switch (action.type) {
    case 'Login_Forgot':
      return 'Forgot'
    case 'Login_Switch':
      return 'Switch'
    case 'Login_Verify':
      return 'Verify'
    case 'Login_Verify_Email':
      return 'Verify_Email'
    case 'Login_Forgot_MOBILE_OTP':
      return 'Forgot_MOBILE_OTP'
    case 'Login_Forgot_SUCCESS':
      return 'Forgot_SUCCESS'
    case 'Login_Profile':
      return 'Profile'
    case 'Login':
      return 'Login'
    case 'Login_SUCCESS':
      return 'Login_SUCCESS'
    default:
      return state
  }
}
export default loginReducer
